import { IBorcAlacak } from "./finance.model";

export interface ITedarikciBorcAlacak extends IBorcAlacak {
    tedarikciID: number;
}

export class TedarikciBorcAlacakFilter {
    tedarikci: string;
    durum: boolean;
}